/*
 * @Version    : v1.00
 * @Author     : generated
 * @Date       : 2025-11-20
 * @desc       : 西班牙语 国际化语言文件
 */
// 西班牙语.js
export default {
  centerAgent: {
    subagency: 'Subagencia',
    search: 'Buscar',
    subagencyIncome: 'Ingresos de Subagencia',
    last29Days: 'Últimos 29 Días',
    excludingToday: 'Excluyendo Hoy',
    commission: 'Comisión',
    last30Days: 'Datos de los Últimos 30 Días',
    rank: 'Clasificación',
    hostNumber: 'Número de Anfitrión',
    recent30Days: 'Ingresos del Anfitrión en los Últimos 30 Días',
    commissionRate: 'Tasa de Comisión',
    myCommission: 'Mi Comisión',
    remove: 'Eliminar',
    thisAction: 'Esta acción eliminará {hostoragent} {hostname} de tu equipo. ¿Confirmas que deseas continuar?',
    dashboard: 'Tablero',
    information: 'Información',
    dataCenter: 'Centro de Datos',
    hostList: 'Lista de Anfitriões',
    bdList: 'Lista de BD',
    agencyList: 'Lista de Agencias',
    myRight: 'Mis Derechos',
    numberOf: 'Número de Agencias',
    inviteAgency: 'Invitar Agencia',
    numberOfHost: 'Número de Anfitriões',
    inviteHost: 'Invitar anfitrión',
    inviteHostlinkcopied: 'Enlace de invitación copiado',
    tipsShare: 'Consejos: comparte el enlace de invitación con tus amigos',
    thisMonthD: 'Datos de Este Mes',
    formDay1: 'De day1 a day2',
    hostGift: 'Puntos de Regalo del Anfitrión',
    agentCommission: 'Comisión de Agente',
    currentLevel: 'Nivel Actual',
    commissionRateOf: 'Tasa de comisión de los ingresos de los agentes',
    baseSalary: 'Salario Base',
    stillNeed: 'Todavía necesito',
    toReach: 'para alcanzar',
    reachedthe: 'Tarea de Publicidad',
    advertisementTask: 'Resumen de Datos',
    dataOverview: 'Resumen de datos',
    today: 'Hoy',
    hostPoint: 'Puntos de Anfitrión',
    agentsPoints: 'Ingresos por Puntos de Agente',
    thisMonth: 'Este Mes',
    month: 'Mes',
    lastMonth: 'Mes Pasado',
    bdNumber: 'Número de BD',
    hostIncome: 'Ingresos del Anfitrión',
    todayIncome: 'Ingresos de Hoy',
    past30Days: 'Últimos 30 Días',
    host: 'Anfitrión',
    country: 'País',
    level7: 'Nivel / Ingresos de 7 Días',
    pointIncome: 'Ingresos por Puntos',
    liveDuration: 'Duración en vivo',
    joinTime: 'Hora de Ingreso',
    state: 'Estado',
    operation: 'Operación',
    bd: 'BD',
    totalHosts: 'Ingresos Totales del Anfitrión',
    totalAgents: 'Ingresos Totales del Agente',
    agent: 'Agente',
    agentLevel: 'Nivel de Agente / Tasa de Comisión',
    commissionIncome: 'Ingresos por Comisión',
    showDirect: 'Mostrar solo agentes directos. Excluyendo datos de hoy',
    excludingTodayData: 'Excluyendo datos de hoy',
    packages: 'Paquetes',
    contents: 'Contenidos',
    balance: 'Saldo',
    release: 'Liberar',
    issue: 'Emitir',
    createBd: 'Crear BD',
    times: 'veces',
    authorizeCs: 'Autorizar CS',
    giftTo: 'Regalar al Usuario',
    bdCreation: 'Límite de Creación de BD Restante',
    csAuthorization: 'Cuota de Autorización CS Restante',
    giftName: 'Nombre del Regalo',
    giftContents: 'Contenido del Regalo',
    check: 'Comprobar',
    cancel: 'Cancelar',
    tip: 'Propina',
    recipientsVip: 'El nivel VIP del destinatario supera el límite del paquete de regalo. Los beneficios VIP de este regalo se desactivarán. ¿Seguro que deseas continuar?',
    confirm: 'Confirmar',
    authorize: 'Autorizar',
    inviteBy: 'Invitar por ID de Usuario',
    invite: 'Invitar',
    inviteLink: 'Enlace de Invitación',
    copy: 'Copiar',
    success: 'Éxito',
    pleaseCheck: 'Por favor verifique la ID de usuario',
    totalGift: 'Ingresos totales por regalos de todos los anfitriones (excluyendo recompensas de plataforma como rankings, tareas, etc.), incluyendo los ingresos por regalos de las subagencias.',
    totalAgentsCom: 'Comisión total de los agentes de los ingresos de sus anfitriones, incluyendo la comisión de los subagentes.',
    allAgent: 'Todos los Agentes',
    directAgent: 'Agente Directo',
    indirectAgent: 'Agente Indirecto',
    newUpgraded: 'Nuevo Agente Actualizado',
    newS: 'Nuevos Agentes S',
    newB: 'Nuevos Agentes B',
    newC: 'Nuevos Agentes C',
    expectedReward: 'Recompensa Esperada',
    newA: 'Nuevos Agentes A',
    agencyLevel: 'Nivel de la Agencia',
    nickname: 'Apodo',
    upgradeDate: 'Fecha de Actualización',
    bdPolicy: 'Política de BD',
    agencyDetail: 'Detalles de la Agencia',
    agency: 'Agencia',
    hostCommission: 'Comisión de Anfitrión',
    last6Days: 'Últimos 6 Días',
    giftIncome: 'Ingreso por Regalos',
    mins: 'mins',
    agencyCenter: 'Centro de Agencia',
    myIncome: 'Mis Ingresos de Hoy',
    totalHost: 'Puntos de Anfitrión Totales',
    overview: 'Resumen Genel',
    hostPoints: 'Puntos de Anfitrión',
    myHosts: 'Mis Puntos de Anfitrión',
    subagentHost: 'Puntos de Anfitrión del Subagente',
    subagencyNumber: 'Número de Subagencias',
    otherIncome: 'Otros Ingresos',
    contactAdmin: 'Contactar al Admin',
    whatsapp: 'WhatsApp',
    bdCenter: 'Centro BD',
    copySuccess: 'Copia Exitosa',
    pleaseInput: 'Por favor, ingrese el monto de la recarga, mínimo 10',
    agencyPolicy: 'Política de Agencia',
    agencyCommission: 'Comisión de Agencia',
    agencyCommission2: 'Comisión de Agencia = Tasa de Comisión × Ingresos Totales por Regalos de Todos los Anfitriones (excluyendo recompensas de plataforma como rankings, tareas, etc.)',
    excludingPlatform: '(excluyendo recompensas de plataforma como rankings, tareas, etc.)',
    agencyCommissionCalculation: 'Cálculo de Comisión de Agencia',
    level: 'Nivel',
    pointsTarget: 'Objetivo de Puntos (Últimos 30 Días)',
    points10000: '10,000 Puntos = 1 USD (M= millón)',
    note1: 'Nota 1: Ingreso Válido Total = Su ingreso de agencia + Ingreso de cada nivel de sus subagencias',
    note2: 'Nota 2: Las comisiones de agencia se acreditarán en tiempo real cuando el anfitrión reciba un regalo.',
    note3: 'Nota 3: El monto mínimo de retiro es de 10 USD, y los retiros deben ser en múltiplos de 10 (por ejemplo: 10 USD, 20 USD, 30 USD).',
    subagencycommission: 'Comisión de Subagencia',
    theMain: 'La agencia principal puede ganar comisiones de los ingresos de cada nivel de subagencias (T1, T2, T3, T4, ... Tn), con una tasa de comisión máxima del 16%.',
    forExample: 'Por ejemplo:',
    agencyA: 'La Agencia A invita a la Agencia B y la Agencia C.',
    agencyB: 'La Agencia B invita a la Agencia D y la Agencia E.',
    agencyC: 'La Agencia C invita a la Agencia F.',
    noteFigures: '(Nota: las cifras entre paréntesis representan los ingresos de los hosts bajo cada agencia).',
    thusWe: 'Por lo tanto, podemos calcular el Ingreso Válido Total y la Tasa de Comisión de las agencias desde la Agencia A hasta la Agencia F.',
    totalValid: 'Ingreso Válido Total = Ingreso de Tu Agencia + Ingreso de Cada Nivel de Subagencia',
    aTotal: 'A Ingreso Válido Total = A + B + C + D + E + F = 10M + 20M + 70M + 20M + 30M +80M = 230M (tasa de comisión del 20%)',
    bTotal: 'B Ingreso Válido Total = B + D + E = 20M + 20M + 30M = 70M (tasa de comisión del 16%)',
    cTotal: 'C Ingreso Válido Total = C + F = 70M + 80M =150M (tasa de comisión del 20%)',
    dTotal: 'D Ingreso Válido Total =20M (tasa de comisión del 12%)',
    eTotal: 'E Ingreso Válido Total =30M (tasa de comisión del 12%)',
    fTotal: 'F Ingreso Válido Total =80M (tasa de comisión del 16%)',
    subagencyCommission: 'Comisión de Subagencia = (Tasa de comisión de la agencia principal - Tasa de comisión de la subagencia) × Ingreso Válido Total de la subagencia',
    agencyAC: 'Comisión de la Agencia {A} de la Agencia {B}',
    thereforeAgency: 'Por lo tanto, comisión total de la Agencia {A} de las subagencias',
    sinceAgency: 'Como las Agencias D, E y F no tienen subagencias, no pueden ganar comisiones de subagencias.',
    seniorPolicy: 'Política Senior',
    nomore: 'No Hay Más Datos',
    active: 'Activo',
    disabled: 'Desactivado',
    deleted: 'Eliminado',
    lastLogintime: 'Última Hora de Inicio de Sesión',
    onmic: 'En el Micrófono Hoy'
  },
  sellerCoin: {
    detailsOf: 'Detalles del Retiro',
    fundsSent: 'Fondos Enviados',
    transfer: 'Transferencia',
    totalIncome: 'Ingreso Total',
    orderIncome: 'Ingresos por Pedido',
    estimatedReward: 'Recompensa Estimada',
    amount: 'Cantidad',
    applicantId: 'ID del Solicitante',
    applicantName: 'Nombre del Solicitante',
    orderId: 'ID de Pedido',
    uploadScreenshot: 'Subir Captura de Pantalla',
    ensureWithdrawal: 'Asegúrese de que el retiro sea exitoso, luego suba la captura de pantalla y haga clic en el botón de abajo para notificar al solicitante.',
    remain: 'Restante',
    pleasePay: 'Pague inmediatamente y suba el recibo. Si excede el límite de tiempo, la elegibilidad de pago del pedido será cancelada.',
    youCan: 'Puedes ganar hasta 5.000 puntos de invitación al día.',
    pleaseComplete: 'Por favor complete el retiro a tiempo ',
    unableTo: 'Incapaz de Pagar, Rechazar',
    notifyThe: 'Notificar al Solicitante',
    youCanGet: 'Puedes obtener un 1% - 3% de bonificación adicional si manejas los pedidos a tiempo.',
    ifYou: 'Si manejas los pedidos en 30 minutos, puedes obtener un 3% de bonificación.',
    egThe: 'Por ejemplo: Un pedido por valor de 90000 puntos, lo manejas en 30 minutos, puedes obtener un 3% de bonificación, que es 90000 × 3% = 2700 puntos.',
    gotIt: 'Entendido',
    pleaseUpload: 'Por favor, sube la imagen',
    detail: 'Detalle',
    balance: 'Balance',
    exchange: 'Intercambiar',
    all: 'Todo',
    recharge: 'Recargar',
    official: 'Oficial',
    exchangeDetail: 'Detalle del Intercambio',
    coinSeller: 'Vendedor de Monedas',
    levelUp: 'Subir de Nivel',
    currentLevel: 'Current level',
    myBalance: 'Mi Saldo',
    details: 'Detalles',
    paymentMethod: 'Método de pago',
    myOrder: 'Mi Pedido',
    paymentMenthod: 'Método de Pago',
    acceptingOrders: 'Aceptando Pedidos',
    unavailable: 'No Disponible',
    greetingMessage: 'Configuración del Mensaje de Bienvenida',
    serviceUnavailable: 'Servicio No Disponible',
    thisFeature: 'Esta función está temporalmente bloqueada. Por favor, contacte al servicio de atención al cliente para obtener ayuda.',
    editMessage: 'Editar Mensaje',
    customizeYour: 'Personaliza tu mensaje de bienvenida. Puedes incluir información útil sobre la recarga de monedas.',
    theMessage: 'El mensaje se enviará automáticamente cuando un nuevo usuario inicie un chat privado contigo',
    save: 'Guardar',
    pleaseEnterMessge: 'Por favor, ingrese su mensaje de bienvenida',
    salesMethod: 'Método de Ventas',
    user: 'Usuario',
    coinseller: 'Vendedor de Monedas',
    userId: 'ID de usuario',
    check: 'Check',
    coinAmount: 'Cantidad de Monedas',
    pleaseEnter: 'Por favor, ingrese un múltiplo de 1',
    enterAt: 'Ingrese al menos 100, en múltiplos de 1',
    transferDetails: 'Detalles de la Transferencia',
    recommendSeller: 'Recomendar Vendedor',
    recent30Day: 'Ventas de Monedas de los Últimos 30 Días',
    whatsapp: 'WhatsApp',
    chat: 'Chat',
    yourCountry: 'Su país actualmente no tiene vendedores de monedas disponibles.',
    pleaseContact: 'Por favor, contacte con el servicio de atención al cliente.',
    customerSupport: 'servicio de atención al cliente',
    contact: 'Contactar',
    customRecharge: 'Recarga Personalizada',
    rechargeDetails: 'Detalles de la Recarga',
    myPoints: 'Mis Puntos',
    todayRemaining: 'Cuota restante de hoy',
    customExchange: 'Intercambio Personalizado',
    exchangeDetails: 'Detalles del Intercambio',
    rechargeRules: 'Reglas de Recarga',
    sellerLevel: 'Nivel del Vendedor',
    proportion: 'Proporción',
    levelRequirement: 'Requisito de Nivel',
    beginner: 'Principiante',
    singleRecharge: 'Recarga única',
    standard: 'Estándar',
    senior: 'Superior',
    exchangeRules: 'Reglas de Intercambio',
    note: 'Note',
    seniorCoin: 'El Vendedor de Monedas Senior obtiene {point} puntos gratis diariamente. Extra en ',
    beginnerSeller: 'Vendedor Principiante',
    standardSeller: 'Vendedor Estándar',
    seniorSeller: 'Vendedor Superior',
    cancel: 'Cancel',
    pleaseInput: 'Please input the recharge amount, minimum 10',
    pleaseInput2: 'Por favor, ingrese el monto de la recarga, múltiplos de 100K',
    confirmation: 'Confirmación',
    userName: 'Nombre de Usuario',
    theUser: 'El usuario ha sido incluido en la lista negra',
    enterAmount: 'Ingresar monto',
    pleaseInput3: 'Por favor, ingrese el monto',
    theAmount: 'El monto debe ser un múltiplo de 100000',
    pleaseInput4: 'Por favor, ingrese o seleccione el monto',
    pleaseSelect: 'Por favor, seleccione el método de ventas',
    pleaseInput5: 'Por favor, ingrese el ID de usuario',
    atLeast: 'Al menos 100K monedas para transferir~',
    pleaseSelect2: 'Por favor, seleccione el método de pago',
    minimum: 'mínimo',
    theAmount3: 'El monto debe ser un múltiplo de 1',
    lessThan: 'menor o igual a 100000',
    orders: 'Pedidos',
    applicant: 'Solicitante',
    method: 'Método',
    withdrawTime: 'Tiempo de Retiro',
    viewDetail: 'Ver Detalle',
    toBe: 'Por confirmar',
    toBePaid: 'Por pagar',
    toBeCompleted: 'Por completar',
    completed: 'Completado',
    abnormal: 'Anormal',
    refused: 'Refused',
    confirmationTimeout: 'Tiempo de confirmación agotado',
    paymentTimeout: 'Tiempo de pago agotado',
    binance: 'Binance',
    scanThe: 'Escanee el código QR para pagar',
    quantity: 'Cantidad',
    orderAmount: 'Monto del pedido',
    date: 'Fecha',
    payNow: 'Pagar Ahora',
    payment: 'Pago',
    pleasePay2: 'Por favor, pague de la siguiente manera',
    chainName: 'Nombre de la Cadena',
    contractAddress: 'Dirección del Contrato',
    theAbove: 'La dirección anterior es válida solo para esta recarga',
    copy: 'Copy',
    notice: 'Aviso',
    pleaseTransfer: 'Por favor, transfiera un Extra 1 USDT para cubrir la tarifa de Binance. Si no lo hace, puede retrasar su recarga de monedas.',
    paymentsMust: 'Los pagos deben completarse dentro de 0.5 horas, o la plataforma no será responsable de ningún problema.',
    add: 'Añadir',
    confirmTo: 'Confirmar para eliminar este método de pago',
    countryCurrency: 'País y Tipo de Moneda',
    selectPayment: 'Seleccione el método de pago que puede remitir',
    coinsSeller: 'Reglas del Vendedor de Monedas',
    standrd: 'Estándar',
    salesMethods: 'Métodos de Ventas',
    coinsellerRules: 'Reglas del CoinSeller',
    whenApplying: 'Al solicitar una actualización al estado de vendedor de monedas, no hay requisitos de depósito, solo necesita 1 recarga para mejorar el nivel de vendedor de monedas. Si elige renunciar a su puesto como vendedor de monedas, su función actual de vendedor de monedas expirará',
    youCanReplenish: 'Puede reponer su cuenta directamente con USDT, Epay o a través de otro vendedor de monedas',
    fraudulentActivities: 'Las actividades fraudulentas están estrictamente prohibidas dentro de la plataforma Hala.',
    anyViolations: 'Cualquier violación resultará en la terminación de la cuenta del vendedor de monedas',
    allRights: 'Todos los derechos reservados por Hala.',
    transferDetail: 'Detalle de la Transferencia'
  },
  centerHost: {
    baseSalary: 'Base Salary',
    invitation: 'Invitación',
    tasks: 'Tareas',
    other: 'Otro',
    consume: 'Consumir',
    giftIncome: 'Gift Income',
    received: 'Recibido',
    from: 'de',
    luckyGift: 'Regalo de la suerte',
    hostCenter: 'Centro de Anfitrión',
    noAgent: 'Sin agente',
    last7: 'Últimos 7 días',
    hourlyIncome: 'Ingreso por hora',
    toReach: 'to reach',
    rules: 'Reglas',
    pointsOverview: 'Resumen de Puntos',
    totalIncome: 'Total Income',
    gifts: 'regalos',
    workDetail: 'Detalle del Trabajo',
    liveDuration: 'Live Duration',
    mins: 'mins',
    todaysLive: 'Registro de hoy en vivo',
    dailyStatistics: 'Estadísticas Diarias',
    startTime: 'Hora de inicio',
    endTime: 'Hora de finalización',
    duration: 'Duración',
    points: 'Agujas',
    date: 'Date',
    giftPoints: 'Puntos de regalo',
    removeBinding: 'Eliminar Vinculación',
    thisAction2: 'Esta acción te desvinculará de {agentName}. Por favor, confirma si deseas proceder con el desvinculamiento'
  },
  bombRule: {
    afterThe: 'Después de que el valor de detonación en la sala alcance cierta cantidad, la bomba de regalo aparecerá en la sala',
    oneCoins: '1 moneda recibida en la sala = 1 valor de detonación',
    itWill: 'Explotará automáticamente después de cumplir con los requisitos, y el propietario de la sala recibirá las recompensas correspondientes en monedas de oro'
  },
  descriptionLevel: {
    wealth: 'Riqueza',
    charm: 'Encanto',
    wealthValue: 'Valor de Riqueza',
    charmValue: 'Valor del Encanto',
    needTo: 'Necesita',
    send: 'enviar',
    receive: 'recibir',
    forThe: 'para la actualización',
    theRich: 'El nivel Rico se cuenta por las monedas que has recargado',
    theCharm: 'El nivel de Encanto se calcula en función de la cantidad de monedas que recibes',
    LevelLabel: 'Etiqueta de Nivel',
    level: 'Level',
    levelLogo: 'Logotipo de Nivel'
  },
  gameRank: {
    gameRank: 'Rango del Juego',
    rules: 'Rules',
    thisWeek: 'Esta Semana',
    lastWeek: 'La Semana Pasada',
    agentGaming: 'Clasificación de Ingresos de Juegos de Agente',
    rankingRewards: 'Recompensas de Clasificación',
    rankingIs: 'La clasificación se basa en la facturación total de apuestas de los usuarios en la sala del agente y sus sub-salas.',
    hostRoom: 'Clasificación de Ingresos de la Sala del Anfitrión',
    rankingIs2: 'La clasificación se basa en los ingresos totales de juegos generados en la sala del anfitrión',
    notes: 'Notas',
    eventDuration: 'Duración del evento: Cada semana calendario. Las recompensas se distribuyen solo si',
    rewardsAre: 'Rewards are distributed only if the corresponding revenue requirements are met.',
    allRewards: 'All rewards will be issued within 1-2 working days after the event ends.',
    halaReserves: 'Hala se reserva el derecho de interpretación final de este evento',
    rewardsDetail: 'Detalle de las Recompensas',
    decorationsPreview: 'Vista Previa de Decoraciones'
  },
  gameLegacyHall: {
    surpriseLucky: 'Bolsa de la Suerte Sorpresa',
    dailyPlayers: 'Los jugadores diarios pueden abrir una Bolsa de la Suerte al día siguiente para monedas aleatorias',
    eventRule: 'Regla del Evento',
    usersSpending: 'El gasto de los usuarios en los juegos del evento contará para su puntuación de clasificación',
    thePlatform: 'La plataforma rotará los juegos del evento cada 4 horas, con 4 juegos diferentes en cada rotación',
    theTop: 'Los 3 mejores jugadores diarios recibirán marcos y recompensas en monedas',
    theTop2: 'Los 10 mejores jugadores semanales recibirán marcos y recompensas en monedas',
    usersWho: 'Los usuarios que participan en los juegos del evento cada día pueden abrir una bolsa de la suerte al día siguiente para recibir una cantidad aleatoria de monedas. Cuanto más gastes en los juegos del evento, más monedas podrás obtener',
    behindPrevious: 'Detrás del anterior',
    thisWeek: 'This Week',
    lastWeek: 'Last Week',
    countdown: 'Cuenta atrás:',
    days: 'días',
    winOver: 'Ganar más de',
    coinsfrom: 'monedas de juegos en un solo día',
    earnOver: 'Ganar más de',
    coinsWitdh: 'con tasa de retorno de hasta',
    fromOneDay: 'de un día en',
    game: 'Juego',
    fromA: 'de una sola apuesta en',
    inthisWeek: 'En Esta Semana',
    earnUp: 'Gana hasta',
    inAsingle: 'en un solo día',
    eventRules: 'Reglas del evento',
    participateIn: 'Participa en el juego para reclamar una bolsa de la suerte más grande mañana',
    youDid: 'No recibiste la recompensa en monedas. Participa en el juego y podrás continuar reclamando la bolsa de la suerte mañana',
    participateIn2: 'Participa en el juego y podrás continuar reclamando la bolsa de la suerte mañana',
    topDaily: 'Mejor Ganador Diario de Monedas',
    topPayout: 'Mejor Ganador de la Tasa de Pago',
    topCoins: 'Mejor Ganador de Monedas en Una Ronda Semanal',
    topPayout2: 'Mejor Ganador de la Tasa de Pago en Una Ronda Semanal',
    topWeekly: 'Mejor Ganador Semanal de Monedas',
    historicalTop: 'Mejor Ganador Histórico de Monedas en Un Día',
    historicalTop2: 'Mejor Ganador Histórico de la Tasa de Pago en Un Día',
    historicalTop3: 'Mejor Ganador Histórico de Monedas en Una Ronda',
    historicalTop4: 'Mejor Ganador Histórico de la Tasa de Pago en Una Ronda',
    historicalTop5: 'Mejor Ganador Histórico de Monedas en Una Semana',
    gameReward: 'Recompensa del juego',
    usersSpending2: 'El gasto de los usuarios en los juegos del evento contará para su puntuación de clasificación',
    theTop3: 'Los 3 mejores jugadores diarios recibirán marcos y recompensas en monedas',
    theTop4: 'Los 10 mejores jugadores semanales recibirán marcos y recompensas en monedas',
    usersWho2: 'Los usuarios que participan en los juegos del evento cada día pueden abrir una bolsa de la suerte al día siguiente para recibir una cantidad aleatoria de monedas. Cuanto más gastes en los juegos del evento, más monedas podrás obtener',
    coins: 'monedas',
    flameRider: 'Jinete de la Llama',
    sportCar: 'Coche Deportivo',
    captainMeow: 'Capitán Miau',
    profileFrame: 'Marco de Perfil'
  },
  gold: {
    coinsDetail: 'Detalle de Monedas',
    coinBalance: 'Saldo de Monedas',
    all: 'ALL',
    sendGifts: 'Enviar Regalos',
    purchaseItems: 'Comprar Artículos',
    games: 'Juegos',
    exchange: 'Exchange',
    recharge: 'Recharge',
    activeReword: 'Recompensas de Actividad',
  },
  integral: {
    all: 'All',
    cashOut: 'Retirar',
    transfer: 'Transfer',
    orderId: 'Order ID',
    paymentMenthod: 'Payment Menthod',
    withdrawalTime: 'Tiempo de Retiro',
    pointsAmount: 'Cantidad de Puntos',
    depositAmount: 'Monto del Depósito',
    coinsAmount: 'Cantidad de Monedas',
    transferTo: 'Transferir a',
    normal: 'Normal',
    pending: 'Pendiente',
    success: 'Success',
    failed: 'Falló',
    points: 'Points',
    pointsBalance: 'Saldo de Puntos',
    frozenPoints: 'Puntos Congelados',
    details: 'Details',
    exchange: 'Exchange',
    currencyType: 'Tipo de Moneda',
    paymentMethod: 'Payment method',
    pointsAmount2: 'Cantidad de puntos para retirar',
    enterA: 'Ingrese un múltiplo de 100,000 (mínimo 200,000)',
    enterA2: 'Ingrese un múltiplo de 100000',
    accountInformation: 'Información de la cuenta',
    withdraw: 'Retirar',
    amount: 'Amount',
    exchangeRate: 'Tipo de cambio',
    exchangePoints: 'Puntos de intercambio',
    enterUserId: 'Ingrese la ID de usuario',
    check: 'Check',
    fee: 'Tarifa',
    theAgency: 'La agencia recibirá',
    transferFee: 'Tarifa de transferencia: 2%. Transferencia mínima ≥ 100,000 puntos.',
    clickTransfer: 'Haga clic en el botón de transferencia para transferir los puntos correspondientes a sus agentes',
    afterThe2: 'Una vez finalizada la transferencia, no se puede cancelar ni retirar',
    transferPoints: 'Puntos de transferencia',
    recommendedMethod: 'Método recomendado',
    lowerFees: 'Tarifas más bajas y revisadas en 24 horas',
    paymentPassword: 'Contraseña de pago no establecida',
    cashOut2: 'Los retiros y los intercambios requieren verificación de contraseña de pago. Por favor, configure primero su contraseña de pago.',
    cancel: 'Cancel',
    goTo: 'Ir a Configuración',
    youHave: 'Has alcanzado 5 intentos fallidos. Un intento fallido más resultará en la congelación de tu cuenta. Si has olvidado tu contraseña, por favor restablécela.',
    inputIncorrect: 'Ingresó la contraseña incorrecta muchas veces. Su cuenta ha sido congelada, por favor intente nuevamente después',
    verify: 'verificar',
    gotIt: 'Got it',
    pointsInfo: 'Información de puntos',
    whenA: 'Cuando un usuario te envía regalos usando Monedas recargadas a través de Google, los puntos que recibes se congelarán durante 7 días antes de estar disponibles. Si el usuario solicita un reembolso, esos puntos se deducirán. Por favor, sigue las reglas de la plataforma y evita cualquier violación.',
    frozenPointsAre: 'Los puntos congelados se incluyen en el saldo total de puntos',
    theUser2: 'El usuario ha sido incluido en la lista negra',
    successfulWithdrawal: 'Retiro exitoso',
    withdrawalAmount: 'Monto del retiro',
    theFunds: 'Los fondos llegarán en 24 horas',
    pleaseEnter2: 'Por favor, ingrese la contraseña',
    passwordIncorrect: 'Contraseña incorrecta',
    theAmount4: 'El monto debe ser un múltiplo de 100000',
    pleaseEnter3: 'Por favor, ingrese la ID de usuario',
    pleaseEnter4: 'Por favor, ingrese la ID de usuario correcta',
    pleaseEnter5: 'Por favor, ingrese el monto',
    minimumTransfer: 'Transferencia mínima ≥ 100,000 puntos',
    pleaseSelect3: 'Por favor, seleccione el método',
    minimum: 'minimum',
    theAmount5: 'El monto debe ser menor que',
    illegalInput: 'Entrada ilegal',
    pleaseEnter6: 'Por favor, ingrese la información de la cuenta'
  },
  invite: {
    inviteGame: 'Invitar usuario del juego',
    currentRebate: 'Rebate actual',
    need: 'necesita',
    toProgress: 'para progresar al siguiente nivel',
    gameReward: 'Game Reward',
    referralData: 'Datos de referencia',
    referralList: 'Lista de referencia',
    date: 'Date',
    gameBets: 'Apuestas del juego',
    inviteRewards: 'Recompensas de invitación',
    viewMore: 'Ver más',
    inviteFriends: 'Invitar amigos',
    myReward: 'Mi recompensa',
    totalRewards: 'Total de recompensas',
    dailyReward: 'Recompensa diaria',
    inviteRules: 'Reglas de invitación',
    yourRebate: 'Tu tasa de rebate depende de tus Apuestas Válidas Totales en los últimos 30 días',
    totalValid2: 'Apuestas Válidas Totales = Tus propias apuestas + Las propias apuestas de cada nivel de tus usuarios invitados',
    rebateFrom: 'Rebate de usuarios invitados de Nivel 1 = Sus propias apuestas × Tu tasa de rebate',
    rebateFrom2: 'Rebate de usuarios invitados de Nivel 2 = Sus propias apuestas × (Tu tasa de rebate - Tasa de rebate del Nivel 1)',
    ifThe: 'Si el usuario invitado de Nivel 2 invita a un usuario de Nivel 3, puede aumentar sus Apuestas Válidas Totales, pero no puede obtener un rebate del Nivel 3.',
    example: 'Ejemplo',
    tier1: 'Nivel 1 invitado - ¿Cómo calcular el rebate de aquellos que son directamente invitados por ti?',
    asRebate: 'Rebate de A de B, C y D = (Apuestas propias de B + Apuestas propias de C + Apuestas propias de D) × Tasa de rebate de A =',
    bsRebate: 'Rebate de B de E y F = (Apuestas propias de E + Apuestas propias de F) × Tasa de rebate de B =',
    csRebate: 'Rebate de C de G = Apuestas propias de G × Tasa de rebate de C =',
    tier2: 'Nivel 2 invitado - ¿Cómo calcular el rebate de aquellos que son indirectamente invitados por ti?',
    asRebate2: 'Rebate de A de E y F = (Tasa de rebate de A - Tasa de rebate de B) × (Apuestas propias de E + Apuestas propias de F) =',
    asRebate3: 'Rebate de A de G = (Tasa de rebate de A - Tasa de rebate de C) × Apuestas propias de G =',
    myInvitation: 'Mi Invitación',
    search: 'Search',
    invitationTime: 'Hora de invitación',
    inviteHost: 'Invite Host',
    inviteA: 'Invitar un anfitrión, cada uno hasta',
    todayRewards: 'Recompensas de hoy',
    rewardDetail: 'Detalle de la recompensa',
    creatorRewards: 'Monedero de Recompensas del Creador',
    collect: 'Recoger',
    invitationDate: 'Fecha de invitación',
    hostPolicy: 'Política de anfitrión',
    halaReserves2: 'Hala se reserva el derecho de interpretación final de las políticas anteriores.'
  },
  listContribution: {
    contributiont: 'Contribución',
    host: 'Host',
    wealth: 'Wealth',
    today: 'Today',
    yesterday: 'Ayer',
    game: 'Game',
    gift: 'Regalo',
    hostEarnings: 'Ganancias del anfitrión'
  },
  missionRule: {
    hostPolicy: 'Host Policy',
    halaReserves3: 'Hala se reserva el derecho de interpretación final de las políticas anteriores'
  },
  purchase: {
    recharge: 'Recharge',
    userId: 'User ID',
    confirm: 'Confirm',
    switchAccount: 'Cambiar de cuenta',
    countryRegion: 'País/Región',
    officialAgency: 'Recarga de agencia oficial',
    ttOff: '20% de descuento',
    totalAmount: 'Monto total',
    purchase: 'Comprar',
    pleaseComfirm: 'por favor, confirme la ID de usuario',
    pleaseInput8: 'Por favor, ingrese la ID de usuario',
    onlineService: 'Servicio en línea',
    dealOf: 'Trato de los últimos 30 días',
    recent30Day2: 'Ventas de monedas de los últimos 30 días',
    paymentMethod: 'Payment Method',
    whatsapp: 'WhatsApp',
    chat: 'Chat',
    yourCountry2: 'Su país actualmente no tiene vendedores de monedas disponibles',
    pleaseContact2: 'Por favor, contacte con el servicio de atención al cliente.',
    customerSupport: 'customer support',
    contact: 'Contact'
  },
  roomGiftRule: {
    eventRules: 'Event Rules',
    treasureChest: 'El progreso del cofre del tesoro aumenta al dar regalos en la sala',
    whenThe: 'Cuando la barra de progreso de la llave del cofre se llene, el cofre del tesouro se abrirá',
    afterThe3: '.Después de que los cofres del tesoro de nivel 3 y 4 cumplan con los requisitos, se bloquearán durante 1 minuto y luego se abrirán automáticamente',
    everyoneIn: 'Todos los presentes en la sala tienen la oportunidad de obtener las recompensas del cofre del tesoro.',
    onceThe: 'Una vez abierto el cofre del tesoro, el sistema puede tardar varios minutos en abonar la recompensa en tu cuenta. Las monedas de oro se añadirán a tu saldo y el traje a tu inventario.',
    theHigher: 'Cuanto mayor sea el nivel del cofre del tesoro, mayores serán las recompensas que contenga.',
    ifYou2: 'Si resulta seleccionado como VIP con un nivel inferior al actual, dicho nivel no tendrá efecto.',
    theProgress: 'La barra de progreso de la llave del cofre se reiniciará a las 00:00 (UTC+5:30) todos los días.'
  },
  share: {
    joinHala: 'Únete a Hala para desbloquear múltiples oportunidades de ingresos y disfrutar de beneficios y recompensas personalizados para agencias.',
    downloadTo: 'Descarga la aplicación para convertirte en socio',
    joinHala2: '¡Únete a Hala para disfrutar de juegos divertidos y la oportunidad de ganar premios increíbles!',
    downloadAnd: '¡Descárgalo y empieza a ganar!',
    joinHala3: '¡Únete a Hala y comienza tu aventura como anfitrión! ¡Gana bonos diarios de hasta $36!',
    inviteYou: 'Te invitamos a unirte a la Agencia',
    downloadNow: 'Descárgalo ahora para empezar a alojar tu sitio web.',
    comeWith: 'Acompáñame a la sala de chat en Hala',
    enthusiastsFrom: 'Aficionados de todo el mundo se reúnen para compartir...',
    igniteEndless: 'Enciende la diversión sin fin',
    download: 'Descargar',
    halaLive: 'Hala en vivo',
    showMe: 'Muéstrame el mundo feliz',
    saySomething: 'Di algo...',
    downloadHala: 'Descarga la aplicación Hala'
  },
  starHost: {
    starHost: 'Presentador estrella',
    level2: 'Nivel {level} mantenido durante {days} días',
    currentSalary: 'Salario actual',
    points: 'Points',
    likes: 'Gustos',
    stillNeed: 'Still need',
    done: 'Hecho',
    numberOf2: 'Número de donantes',
    gifters: 'Donadores',
    gcoinGifts: 'Regalos de Gcoin',
    gifts: 'gifts',
    liveDuration: 'Live Duration',
    min: 'mínimo',
    completeAll: 'Completa todas las siguientes tareas para actualizar',
    follower: 'Seguidor',
    numberOf3: 'Número de donantes',
    daysAt: 'Días en el nivel ',
    giftCollection: 'Colección de regalos',
    gift: 'Gift',
    date: 'Date',
    expectedSalary: 'Sueldo esperado',
    gcoin: 'Gcoin',
    status: 'Estado',
    levelReached: ' Nivel alcanzado',
    notAchieved: 'No se logró',
    starHost2: 'Reglas del presentador estrella',
    eachStar: 'Cada anfitrión estrella tiene un período de prueba de 3 días.',
    theyWill: 'Solo se convertirán en presentadores estrella oficiales si cumplen con los estándares de nivel A durante los 3 días.',
    thoseWho: 'Quienes no alcancen los objetivos diarios de nivel avanzado serán despedidos.',
    firedHosts: 'Los presentadores despedidos no pueden percibir el salario base de Presentador Estrella.',
    starHost3: 'El salario base de Star Host se paga semanalmente, todos los lunes.',
    ifA: 'Si un Anfitrión Estrella no completa las tareas diarias, solo recibirá el 50% de su salario por hora.',
    selfGifting: 'Los autorregalos están estrictamente prohibidos para todos los destinatarios de regalos.',
    starHost4: 'Recompensas de Anfitrión Estrella de Diferentes Niveles',
    level: 'Level',
    dailyExtra: 'Recompensas diarias de puntos extra',
    liveBroadcast: 'Se requiere tiempo de transmisión en vivo',
    starHost5: 'Requisitos de Star Host para diferentes niveles',
    requirements: 'Requisito(s)',
    yourApplication: 'Su solicitud ha sido aprobada por las autoridades.',
    stayOn: 'Mantente en el nivel A durante 7 días',
    over1k: 'Más de 1000 fans',
    totalGifter: 'Número total de donantes > 300',
    receiveAll: 'Recibe todos los regalos de la suerte',
    everyLucky: 'Cada número de regalos de la suerte debe ser mayor que 100.',
    stayOn2: 'Permanece en el Nivel S durante 10 días',
    over2k: 'Más de 2 mil fans',
    totalGifter2: 'Número total de donantes > 300',
    receiveAll2: 'Recibe todos los regalos "populares".',
    stayOn3: 'Permanece en el nivel SS durante 10 días',
    over5k: 'Más de 5 mil seguidores',
    totalGifter3: 'Número total de donantes > 1000',
    receiveAll3: 'Reciba todos los regalos de "lujo".',
    starHost6: 'Tareas diarias del presentador estrella',
    dailyAssessment: '(Sistema de evaluación diaria): Interacción / Regalos',
    gcionGifts: 'Regalos Gcion',
    rulesTo: 'Reglas para degradar el nivel de anfitrión estelar',
    failTo: 'No alcanzar los estándares del nivel actual durante 3 días consecutivos.',
    failingTo: 'Incumplir los estándares 3 veces en una semana',
    ifThe2: 'Si el anfitrión que no cumple con el requisito diario es de nivel A, será despedido directamente en lugar de ser degradado. Tras ser degradado, el anfitrión deberá cumplir con los estándares de su nivel original durante 3 días consecutivos para recuperarlo.',
    involvementIn: 'Participación en infracciones graves o incidentes negativos.',
    causingDamage: 'Causar daño a los intereses o la imagen de marca de la plataforma.',
    applyFor: 'Solicita renunciar por tu cuenta',
    liveStreaming: 'Requisitos para la transmisión en vivo',
    liveStream: 'El contenido de la transmisión en vivo debe ajustarse al tipo designado por el anfitrión.',
    roomHosts: 'Los anfitriones de sala tienen prohibido silenciar su micrófono durante períodos prolongados durante las transmisiones.',
    liveStreams: 'Las transmisiones en directo deben realizarse utilizando una sala con micrófonos con capacidad para 9 personas.',
    otherSeats: 'No está permitido que otros asientos de la sala sean ocupados por usuarios o miembros del público que silencien sus micrófonos con fines de agrupación de tareas.',
    discriminatoryInsulting: 'En la sala están estrictamente prohibidos los comentarios discriminatorios, insultantes u ofensivos.'
  },
  starRoom: {
    afterCountdown: 'Tras la cuenta atrás diaria, las 3 mejores habitaciones aparecerán en el Ranking de Habitaciones Estrella.',
    top20Star: 'Las 20 mejores habitaciones con estrellas recibirán una generosa bonificación después de esta semana.',
    countdown: 'Countdown：',
    top3Daily: 'Las 3 mejores salas diarias podrán unirse a las salas estrella semanales.',
    starRooms: 'Las salas estrella se clasificarán el último día de la semana. La clasificación se basará en el flujo total de monedas de cada sala.',
    top20Weekly: 'Los 20 mejores propietarios de habitaciones con estrellas de la semana recibirán las siguientes recompensas.',
    qualificationTo: 'Requisitos para participar en este evento: No se permiten infracciones ni comportamientos ilegales en la sala. Si se detecta alguna, Hala descalificará la sala y la eliminará del ranking.',
    theRewards: 'Las recompensas se enviarán todos los lunes.',
    days: 'days',
    coins: 'Coins'
  },
  inviteActive: {
    inviteHosts: 'Invitar a los anfitriones',
    pointsMax: '5000 puntos máximos diarios',
    firstRecharge: 'Usuarios de primera recarga',
    get20: 'Obtén $20 gratis',
    oneInvite: '1. Invita a los anfitriones a comenzar en vivo cuando los anfitriones que invitaste terminen.',
    aFinish: 'a. Finalice la verificación facial en el centro de tareas',
    bCreate: 'b. Crear su propia habitación',
    cLive: 'c. Transmitió en directo por micrófono durante 3 horas en su habitación.',
    dClaim: 'd.Reclama las recompensas en directo por primera vez',
    youGet: 'Obtendrás puntos de recompensa diariamente gracias a los números de tus anfitriones invitados válidos. Podrás reclamar las recompensas al día siguiente.',
    validHost: 'Host válido',
    pointsReward: 'Recompensa por puntos',
    youCan: ' You can earn up to 5,000 invite points per day',
    myInvited: 'Mis anfitriones invitados',
    validHosts: 'Anfitriones válidos hoy',
    pointsRewards: 'Recompensas por puntos',
    validHosts2: 'Hosts válidos ayer:',
    claim: 'Afirmar',
    claimed: 'Reclamado',
    completedTime: 'Tiempo completado',
    ifYour: 'Si tus amigos completan la primera recarga, recibirás muchas recompensas. (Las recargas sin conexión también están incluidas).',
    theMore: 'Cuanto mayor sea el monto de la primera recarga, más monedas recibirás como recompensa, hasta un máximo de $20 diarios.',
    inviteesRecharge: 'Invitados Recargan monedas',
    yourReward: 'Tus monedas de recompensa',
    threeOnly: '3. Únicamente los usuarios que reciban una invitación para recargar dentro de los 30 días serán considerados usuarios válidos de primera recarga.',
    seniorAnd: 'Los vendedores senior y estándar solo se contabilizarán cuando recarguen desde la aplicación o directamente desde la plataforma oficial (consulte con su administrador para conocer los métodos de pago). Los usuarios que realicen su primera recarga serán considerados usuarios válidos de primera recarga.',
    myInvited2: 'Mis usuarios invitados',
    rechargeCoins: 'Monedas de recarga',
    coinsRewards: 'Recompensas en monedas',
    firstRecharge2: 'Monedas de la primera recarga de ayer:',
    firstRecharge3: 'Monedas de primera recarga',
    firstRecharge4: 'Tiempo de primera recarga'
  },
  hostPolicy: {
    title: 'Política de Host',
    section1Title: 'Salario Base de la Primera Semana para Nuevos Hosts',
    requirement: 'Requisito',
    newHostsDesc: 'Nuevos hosts que se unieron a Hala en la primera semana',
    activeTime: 'Tiempo Activo en Micrófono',
    oneHour: '1 Hora',
    twoHour: '2 Horas',
    threeHour: '3 Horas',
    baseSalary: 'Salario Base (Puntos)',
    incomeRequirement: 'Requisito de Ingresos',
    none: 'Ninguno',
    remarks: 'Observaciones',
    remarksDesc: 'Máximo 3 horas/día. Máximo 7 días. Recompensa máxima total de 35,000 puntos',
    note1: 'Desde la fecha de registro del host, comienza la cuenta regresiva del período de validez del salario básico de 7 días.',
    note2: 'Los hosts que usen múltiples cuentas o inicien sesión con múltiples IPs o dispositivos serán descalificados de la recompensa de salario base.',
    note3: 'Si los ingresos de los últimos 7 días del host superan los 150,000 puntos, obtendrá la Recompensa por Hora de Host Ordinario en lugar de la Recompensa de Salario Base de Nuevo Host.',
    section2Title: 'Recompensa Equitativa para Host Ordinario',
    level: 'Nivel',
    incomeRequirementShort: 'Requisito de Ingresos',
    hourlyReward: 'Recompensa por Hora',
    maximumDailyHours: 'Horas Máximas Diarias',
    section2Note1: '15 minutos continuos en micrófono se contarán como tiempo efectivo.',
    section2Note2: 'Todas las recompensas se liquidan en puntos y deben reclamarse en el sistema de tareas.',
    section2Note3: 'Las recompensas de la plataforma no se contarán para el requisito de puntos.',
    section2Note4: 'Los puntos se deducirán una vez que se detecten múltiples IPs o dispositivos.',
    section2Note5: 'Los últimos 7 días significan los últimos 6 días+hoy, por lo que sus recompensas por hora pueden aumentar a medida que alcanza niveles de puntos más altos a tiempo.',
    section2Note6: 'Las recompensas de no objetivo de nivel L solo serán válidas durante los primeros 7 días después del registro. Después de 7 días, los hosts pueden obtener 500 puntos gratis permanentemente todos los días.',
    section3Title: 'Regulaciones del Host',
    regulation1: 'Está prohibido que los hosts registren múltiples cuentas.',
    regulation2: 'Está prohibido promocionar plataformas de terceros.',
    regulation3: 'Están estrictamente prohibidos los menores de edad.',
    regulation4: 'Un host solo puede tener una ID verificada. Solo las IDs verificadas pueden comenzar a transmitir en vivo y retirar ganancias.',
    regulation5: 'Cualquier acto de suplantación de autenticación facial para comenzar a transmitir en vivo o retirar ganancias será prohibido permanentemente.',
    regulation6: 'Proporcionar la ID a otros para transmitir en vivo resultará en que la ID sea prohibida permanentemente por el sistema.',
    regulation7: 'En la sala de voz, los hosts deben saludar activamente a los usuarios que ingresen a la sala.',
    regulation8: 'La foto de portada de la sala de voz debe usar una foto real y compliant del host.',
    regulation9: 'La plataforma Hala prohíbe estrictamente cualquier actividad fraudulenta. Cualquier violación resultará en la suspensión permanente de la cuenta.',
    footer: 'Hala se reserva el derecho de interpretación final de las políticas anteriores.',
  },
  correspondingRevenue: 'se cumplen los requisitos de ingresos correspondientes. Todas las recompensas se emitirán',
  within12: 'dentro de 1-2 días laborables después de que finalice el evento'
}
